import { FormControlLabel } from "@material-ui/core";

export default FormControlLabel;
